<div class="container vertical-center d-grid animated fadeIn fast">
  <div class="jumbotron-fluid vertical-center row">
    <div class="frame frame-login-clients center-block">
      <div class="row">
        <img
          style="position: relative"
          class="center-block"
          src="assets/images/login/Frame.png"
        />
        <img
          style="position: absolute"
          class="logo-login"
          src="assets/images/login/logo-bf-vertical.png"
        />
      </div>
      <div class="row row-title text-center">
        <h3 class="title secondary"><strong>Login</strong> Empresa</h3>
        <div id="space-bar" class="space-bar center-block"></div>
        <app-alert *ngIf="error" [alert]="error"></app-alert>
        <app-alert
          *ngIf="
            helpers.invalidControl(companyForm.get('ruc')) &&
            !companyForm.get('ruc').errors.required
          "
          [alert]="constants.alerts.invalidRuc"
        ></app-alert>
      </div>
      <div class="login-form center-block">
        <app-loading *ngIf="loading"></app-loading>
        <form
          *ngIf="!loading"
          [formGroup]="companyForm"
          [class.mt-10]="anyAlert()"
          appBlockCopyPaste
        >
          <div
            class="form-group"
            [class.has-error]="helpers.invalidControl(companyForm.get('ruc'))"
          >
            <label for="ruc" class="label-form">RUC de la empresa</label>
            <input
              type="text"
              formControlName="ruc"
              maxlength="11"
              class="form-control"
              mask="0*"
            />
            <span
              class="help-block invalid-feedback"
              *ngIf="helpers.invalidControl(companyForm.get('ruc'))"
            >
              <span *ngIf="companyForm.get('ruc').errors.required">{{
                constants.validations.required.message
              }}</span>
            </span>
          </div>
          <div
            class="form-group has-feedback"
            [class.has-error]="
              helpers.invalidControl(companyForm.get('docType'))
            "
          >
            <label for="docType" class="label-form">Tipo de documento</label>
            <select
              class="form-control"
              formControlName="docType"
              (change)="onChange($event)"
            >
              <option value="" disabled selected>Selecciona</option>
              <option *ngFor="let type of docTypes" value="{{ type.value }}">
                {{ type.name }}
              </option>
            </select>
            <i
              class="glyphicon glyphicon-menu-down form-control-feedback custom-select-arrow"
            ></i>
            <span
              class="help-block invalid-feedback"
              *ngIf="helpers.invalidControl(companyForm.get('docType'))"
            >
              <span *ngIf="companyForm.get('docType').errors.required">{{
                constants.validations.required.message
              }}</span>
            </span>
          </div>

          <div
            class="form-group"
            [class.has-error]="
              helpers.invalidControl(companyForm.get('docNumber'))
            "
          >
            <label for="docNumber" class="label-form"
              >Número de documento</label
            >
            <input
              type="text"
              formControlName="docNumber"
              class="form-control"
              [maxlength]="maxLengthDoc"
              mask="0*"
              
            />

            <span
              class="help-block"
              *ngIf="helpers.invalidControl(companyForm.get('docNumber'))"
            >
              <span *ngIf="companyForm.get('docNumber').errors.required">{{
                constants.validations.required.message
              }}</span>
              <span
                *ngIf="
                  companyForm.get('docNumber').errors.pattern ||
                  companyForm.get('docNumber').errors.maxlength ||
                  companyForm.get('docNumber').errors.minlength
                "
                >{{
                  constants.validations.docNumber.message(
                    companyForm.get("docNumber").errors.minlength?.requiredLength || maxLengthDoc
                  )
                }}</span
              >
            </span>
          </div>
          <div
            class="form-group"
            [class.has-error]="
              helpers.invalidControl(companyForm.get('password'))
            "
          >
            <label for="password" class="label-form">Clave</label>
            <input
              type="password"
              formControlName="password"
              maxlength="6"
              class="form-control"
            />
            <span
              class="help-block"
              *ngIf="helpers.invalidControl(companyForm.get('password'))"
            >
              <span *ngIf="companyForm.get('password').errors.required">{{
                constants.validations.required.message
              }}</span>
              <span *ngIf="companyForm.get('password').errors.pattern">{{
                constants.validations.numeric.message
              }}</span>
              <span
                *ngIf="
                  companyForm.get('password').errors.minlength &&
                  !companyForm.get('password').errors.pattern
                "
                >{{ constants.validations.minDigits.message }}</span
              >
            </span>
          </div>

          <div class="form-group">
            <button
              [disabled]="companyForm.invalid"
              (click)="login()"
              class="button-continue center-block btn-block button-find-label"
            >
              Continuar
            </button>
          </div>
          <div class="row">
            <div class="col-md-4 col-sm-6 text-left">
              <a
                (click)="navigateTo('/create-account')"
                class="primary green-link pointer"
                >Crear cuenta ></a
              >
            </div>
            <div class="col-md-8 col-sm-6 text-right">
              <a
                (click)="navigateTo('/recover-password')"
                class="primary green-link pointer"
                >Crear o recuperar contraseña ></a
              >
            </div>
          </div>
          <div class="row text-center">
            <div class="space-bar-bottom"></div>
            <a
              *ngIf="!loading"
              [routerLink]="['/login/executive']"
              class="secondary bottom-link"
              >Ir a Login Banco</a
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
